import React from 'react';

import cn from 'classnames';

import { Button } from '../../../../components';
import SvgImage from '../../../../components/svg-image';
import { i18n } from '../../../../helpers/i18n';
import styles from './styles.css';

const starIcon = <SvgImage noContainer imageName="star" className={styles.starIcon} />;

interface StarsProps {
    onRatingChange(rating: number): void;
}

const TOTAL_COUNT = 5;

const RATING = Array.from({ length: TOTAL_COUNT }, (_, i) => TOTAL_COUNT - i);

export const Stars: React.FunctionComponent<StarsProps> = ({ onRatingChange }) => {
    const [rating, setRating] = React.useState<number>();

    const handleRatingChange = (newRating: number) => {
        setRating(newRating);
        onRatingChange(newRating);
    };

    return (
        <div className={styles.stars}>
            {RATING.map((i) => (
                <Button
                    key={i}
                    size="lg"
                    className={cn(styles.starButton, { [styles.starButtonActive]: rating && rating >= i })}
                    view="neutral-transparent"
                    data-test-id={`rating_${i}`}
                    icon={starIcon}
                    onClick={() => handleRatingChange(i)}
                    aria-label={i18n('feedback', 'star-rate', { index: i, count: TOTAL_COUNT })}
                />
            ))}
        </div>
    );
};
